import { DateOptionModel } from '../../section-wise/models/date-option.model';

export class Utils {
  public static readonly defaultDateFormat = 'MM/dd/yyyy';

  static getBaseRoute() {
    return window.location.pathname.includes('seguros-de-salud/calcular') ? '/seguros-de-salud/calcular' : '/datos-comparativa';
  }

  static getDateOption(dateObject: Date | string | null): DateOptionModel {
    const dateOption = new DateOptionModel();

    if (typeof dateObject === 'string') {
      dateObject = new Date(dateObject);
    }

    if (dateObject instanceof Date && !isNaN(dateObject.getTime())) {
      dateOption.day = dateObject.getDate();
      dateOption.month = dateObject.getMonth() + 1;
      dateOption.year = dateObject.getFullYear();
    }

    return dateOption;
  }

  static getDateString(selectedDate: DateOptionModel, format: string = Utils.defaultDateFormat): string {
    const { day, month, year } = selectedDate;

    if (day === null || month === null || year === null) {
      throw new Error('Invalid date option: day, month, and year must not be null');
    }

    const formattedDate = format
      .replace('dd', day.toString().padStart(2, '0'))
      .replace('MM', month.toString().padStart(2, '0'))
      .replace('yyyy', year.toString());

    return formattedDate;
  }

  static isNumber(evt: any): boolean {
    evt = evt ? evt : window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
